module.exports = __webpack_public_path__ + "static/media/ico_myteam_active.a67da4e6.svg";